import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

const DialogHeader = ({ title, subtitle }) => (
  <Modal.Header>
    <h4 className="m-0 text-2xl font-bold text-gray-900">{title}</h4>
    <p className="m-0 mt-1 text-sm text-gray-900">{subtitle}</p>
  </Modal.Header>
)

DialogHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
}

export default DialogHeader
